import { useState } from 'react';
import { isPhoneNumberValid, returnOnlyNumbers, isValidEmail } from '../components/AccountForm/utilities/accountFormUtilities';
import { validatePassword } from '../components/AccountForm/utilities/passwordValidation';
import { validateValidationCode } from '../components/Verify/utilities/VerifyUtilities';
import styles from '../global/globalStyles.module.scss';
import { useFriendContext } from '../utils/ContextProviders/FriendContext';

export const VALID_CLASS = styles.valid;
export const INVALID_CLASS = styles.invalid;

// TODO: remove valid class - no longer want this according to feedback from design team
export default function useValidateValue() {
  const { friend, setFriend } = useFriendContext();
  const [validationClass, setValidationClass] = useState('');
  function validateValue(name: string, value: string) {
    if (name === 'password') {
      return validatePassword(value)
        ? setValidationClass(VALID_CLASS) : setValidationClass(INVALID_CLASS);
    }
    if (name === 'shipAddress2') {
      if (value.length > 0) {
        return setValidationClass(VALID_CLASS);
      }
      return '';
    }
    if (name === 'email') {
      if (!friend.isEmailUnique) {
        setFriend({ ...friend, isEmailUnique: true });
      }
      return isValidEmail(value)
        ? setValidationClass(VALID_CLASS) : setValidationClass(INVALID_CLASS);
    }
    if (name === 'phoneNumber') {
      if (!friend.isPhoneNumberUnique) {
        setFriend({ ...friend, isPhoneNumberUnique: true });
      }
      return isPhoneNumberValid(returnOnlyNumbers(value), friend.countryCode)
        ? setValidationClass(VALID_CLASS) : setValidationClass(INVALID_CLASS);
    }
    if (name === 'verificationCode') {
      if (value) {
        return validateValidationCode(value)
          ? setValidationClass(VALID_CLASS) : setValidationClass(INVALID_CLASS);
      }

      return validateValidationCode('');
    }
    if (value.length > 0) {
      return setValidationClass(VALID_CLASS);
    }
    return setValidationClass(INVALID_CLASS);
  }
  return {
    validationClass,
    validateValue,
  };
}
